export type WebSocketMessageAccessConfigType =
  | "teacher"
  | "student"
  | "both"
  | "none";
const asAccessConfigType = <T>(accessConfig: {
  [K in keyof T]: WebSocketMessageAccessConfigType;
}) => accessConfig;

export const WebSocketMessageAccessConfig = asAccessConfigType({
  NOTIFICATION_RECEIVED: "both",
  FORUM_MENTION_RECEIVED: "both",
  FORUM_THREAD_CREATED: "both",
  FORUM_THREAD_UPDATED: "both",
  FORUM_THREAD_REACTION_CHANGED: "both",
  FORUM_POST_REACTION_CHANGED: "both",
  FORUM_POST_CREATED: "both",
  FORUM_POST_UPDATED: "both",
  FORUM_POST_DELETED: "both",
  EXERCISE_ADDED: "both",
  EXERCISE_DELETED: "both",
  EXERCISE_HELP_TURNED_ON: "both",
  EXERCISE_HELP_TURNED_OFF: "both",
  EXERCISE_STARTED: "none",
  EXERCISE_STATUS_UPDATE: "none",
  EXERCISE_START_FAILURE: "none",
  EXERCISE_SOLVED: "teacher",
  STUDENT_SUSPENDED: "both",
  VPN_UPDATED: "both",
  USER_VPN_UPDATED: "teacher",
  CODE_CHECK_RESULT: "none",
  CODE_CHECK_RUN_RESULT: "none",
  RANKING_CHANGED: "none",
  EXERCISE_QUIZ_SOLUTIONS_TURNED_ON: "both",
  EXERCISE_QUIZ_SOLUTIONS_TURNED_OFF: "both",
  EXERCISE_REVIEWED: "student",
  EXERCISE_REVIEW_COMMENT: "student",
  STUDENT_HELP_REQUEST_CREATED: "teacher",
  STUDENT_HELP_REQUEST_CANCELED: "teacher",
  EXERCISE_SHORT_ANSWER_REVIEWED: "student",
  EXERCISE_SHORT_ANSWER_SUBMITTED: "teacher",
  SCHEDULE_ON: "both",
  SCHEDULE_OFF: "both",
  PDFREPORT_GENERATED: "teacher",
  BULK_DOWNLOAD_PROGRESS: "teacher",
  BULK_DOWNLOAD_COMPLETE: "teacher",
  EXERCISE_FILE_UPLOADED: "teacher",
  EXERCISE_FILE_UPLOAD_CANCELED: "teacher",
  CHAT_MESSAGE_CREATED: "both",
  CHAT_MESSAGE_DELETED: "both",
  CHAT_MESSAGES_READ: "both",
  ATTENDANCE_CHECKS_CREATED: "none",
  ATTENDANCE_CHECK_UPDATED: "none",
  ATTENDANCE_CHECK_DELETED: "none",
  ATTENDANCE_CHECK_FINALIZED: "none",
  ATTENDANCE_RECORD_UPDATED: "none",
});

export type WebSocketMessageType = keyof typeof WebSocketMessageAccessConfig;
